/* ============================================
   ELSTAR CUSTOM THEME - JavaScript (Enhanced)
   ============================================ */

(function() {
  'use strict';

  /* --- LAZY LOADING IMAGES --- */
  if ('IntersectionObserver' in window) {
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    var imageObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-loaded');
          imageObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });

    lazyImages.forEach(function(img) {
      if (img.complete) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', function() {
          img.classList.add('is-loaded');
        });
        imageObserver.observe(img);
      }
    });
  } else {
    // Fallback: show all images
    document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      img.classList.add('is-loaded');
    });
  }

  /* --- SCROLL REVEAL ANIMATIONS --- */
  if ('IntersectionObserver' in window) {
    var revealElements = document.querySelectorAll(
      '.section, .section-title, .collection-card, .banner-card, .banner-card-v2, ' +
      '.product-card, .newsletter-box, .rich-text, .product-tabs, .related-products'
    );

    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    revealElements.forEach(function(el, index) {
      // Set stagger index for grid children
      var parent = el.parentElement;
      if (parent && (parent.classList.contains('collection-grid') ||
                     parent.classList.contains('product-grid') ||
                     parent.classList.contains('banner-grid'))) {
        var siblings = parent.children;
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] === el) {
            el.style.setProperty('--reveal-index', i);
            break;
          }
        }
      }
      revealObserver.observe(el);
    });
  } else {
    // Fallback: show all elements
    document.querySelectorAll(
      '.section, .section-title, .collection-card, .banner-card, .banner-card-v2, ' +
      '.product-card, .newsletter-box, .rich-text, .product-tabs, .related-products'
    ).forEach(function(el) {
      el.classList.add('is-revealed');
    });
  }

  /* --- HEADER SCROLL SHADOW --- */
  var header = document.querySelector('.site-header');
  if (header) {
    var lastScrollY = 0;
    window.addEventListener('scroll', function() {
      var scrollY = window.scrollY;
      if (scrollY > 10) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScrollY = scrollY;
    }, { passive: true });
  }

  /* --- MOBILE MENU --- */
  var menuToggle = document.querySelector('.menu-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileNavOverlay = document.querySelector('.mobile-nav-overlay');
  var mobileNavClose = document.querySelector('.mobile-nav-close');

  function openMobileMenu() {
    if (mobileNav) mobileNav.classList.add('is-active');
    if (mobileNavOverlay) mobileNavOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileNav) mobileNav.classList.remove('is-active');
    if (mobileNavOverlay) mobileNavOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileMenu);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileMenu);

  /* --- SEARCH OVERLAY --- */
  var searchToggle = document.querySelector('.search-toggle');
  var searchOverlay = document.querySelector('.search-overlay');
  var searchClose = document.querySelector('.search-close');

  function openSearch() {
    if (searchOverlay) {
      searchOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      var input = searchOverlay.querySelector('input');
      if (input) setTimeout(function() { input.focus(); }, 200);
    }
  }

  function closeSearch() {
    if (searchOverlay) {
      searchOverlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  /* --- HERO CAROUSEL --- */
  document.querySelectorAll('.hero-carousel').forEach(function(carousel) {
    var slides = carousel.querySelector('.hero-slides');
    var allSlides = carousel.querySelectorAll('.hero-slide');
    var dots = carousel.querySelectorAll('.hero-dot');
    var prevBtn = carousel.querySelector('.hero-arrow--prev');
    var nextBtn = carousel.querySelector('.hero-arrow--next');
    var currentIndex = 0;
    var total = allSlides.length;
    var autoplayInterval;

    if (total <= 1) return;

    function goToSlide(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      currentIndex = index;
      slides.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === currentIndex);
      });

      // Re-trigger fade animations on new slide
      var activeSlide = allSlides[currentIndex];
      var fadeEls = activeSlide.querySelectorAll('.hero-fade');
      fadeEls.forEach(function(el) {
        el.style.animation = 'none';
        el.offsetHeight; // trigger reflow
        el.style.animation = '';
      });
    }

    function nextSlide() { goToSlide(currentIndex + 1); }
    function prevSlide() { goToSlide(currentIndex - 1); }

    if (nextBtn) nextBtn.addEventListener('click', function() { nextSlide(); resetAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function() { prevSlide(); resetAutoplay(); });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(this.getAttribute('data-slide')));
        resetAutoplay();
      });
    });

    // Autoplay
    function startAutoplay() {
      autoplayInterval = setInterval(nextSlide, 5000);
    }
    function resetAutoplay() {
      clearInterval(autoplayInterval);
      startAutoplay();
    }
    startAutoplay();

    // Pause on hover
    carousel.addEventListener('mouseenter', function() { clearInterval(autoplayInterval); });
    carousel.addEventListener('mouseleave', startAutoplay);

    // Touch support
    var touchStartX = 0;
    carousel.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      clearInterval(autoplayInterval);
    }, { passive: true });
    carousel.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) nextSlide();
        else prevSlide();
      }
      startAutoplay();
    }, { passive: true });
  });

  /* --- PRODUCT TABS --- */
  var tabButtons = document.querySelectorAll('.product-tabs-nav button');
  var tabContents = document.querySelectorAll('.product-tab-content');

  tabButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = this.getAttribute('data-tab');

      tabButtons.forEach(function(b) { b.classList.remove('is-active'); });
      tabContents.forEach(function(c) { c.classList.remove('is-active'); });

      this.classList.add('is-active');
      var panel = document.getElementById(target);
      if (panel) panel.classList.add('is-active');
    });
  });

  /* --- PRODUCT GALLERY THUMBS --- */
  var galleryThumbs = document.querySelectorAll('.product-gallery-thumb');
  var galleryMain = document.querySelector('.product-gallery-main img');

  galleryThumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = this.getAttribute('data-src');
      var zoomSrc = this.getAttribute('data-zoom-src');
      if (galleryMain && src) {
        galleryMain.src = src;
        if (zoomSrc) galleryMain.setAttribute('data-zoom-src', zoomSrc);
        galleryThumbs.forEach(function(t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
      }
    });
  });

  /* --- LIGHTBOX (Image Zoom) --- */
  var lightbox = document.getElementById('lightbox');
  var lightboxImg = document.getElementById('lightbox-img');
  var lightboxClose = document.querySelector('.lightbox-close');
  var lightboxTrigger = document.querySelector('[data-lightbox-trigger]');

  if (lightboxTrigger && lightbox) {
    lightboxTrigger.addEventListener('click', function() {
      var mainImg = this.querySelector('img');
      if (mainImg) {
        var zoomSrc = mainImg.getAttribute('data-zoom-src') || mainImg.src;
        lightboxImg.src = zoomSrc;
        lightbox.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }
    });
  }

  if (lightboxClose) {
    lightboxClose.addEventListener('click', function() {
      lightbox.classList.remove('is-active');
      document.body.style.overflow = '';
    });
  }

  if (lightbox) {
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) {
        lightbox.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    });
  }

  /* --- QUANTITY SELECTOR --- */
  document.querySelectorAll('.quantity-selector').forEach(function(selector) {
    var input = selector.querySelector('input');
    var minus = selector.querySelector('.qty-minus');
    var plus = selector.querySelector('.qty-plus');

    if (minus) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }

    if (plus) {
      plus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  /* --- ADD TO CART (AJAX) with feedback toast --- */
  var cartFeedback = document.getElementById('cart-feedback');

  function showCartFeedback() {
    if (cartFeedback) {
      cartFeedback.classList.add('is-active');
      setTimeout(function() {
        cartFeedback.classList.remove('is-active');
      }, 2500);
    }
  }

  var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(this);
      var submitBtn = this.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Aggiunto!';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        updateCartCount();
        showCartFeedback();
        setTimeout(function() {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        }, 1500);
      })
      .catch(function() {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var countEls = document.querySelectorAll('.cart-count');
        countEls.forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }

  /* --- STICKY ADD-TO-CART BAR --- */
  var stickyBar = document.getElementById('sticky-atc-bar');
  var addToCartSection = document.getElementById('product-add-to-cart-main');

  if (stickyBar && addToCartSection) {
    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else {
          // Only show when scrolled past (not above)
          if (entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('is-visible');
          } else {
            stickyBar.classList.remove('is-visible');
          }
        }
      });
    }, { threshold: 0 });

    stickyObserver.observe(addToCartSection);
  }

  /* --- COLLECTION FILTERS (AJAX) --- */
  var filterForm = document.querySelector('.collection-filters-form');
  var collectionProducts = document.querySelector('.collection-products');

  if (filterForm && collectionProducts) {
    filterForm.addEventListener('change', function() {
      var formData = new FormData(filterForm);
      var params = new URLSearchParams(formData).toString();
      var url = window.location.pathname + '?' + params;

      // Show loading state
      collectionProducts.classList.add('is-loading');

      fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newProducts = doc.querySelector('.collection-products');
          var newPagination = doc.querySelector('.pagination');
          var currentPagination = document.querySelector('.pagination');

          if (newProducts) {
            collectionProducts.innerHTML = newProducts.innerHTML;
          }
          if (currentPagination && newPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
          }

          collectionProducts.classList.remove('is-loading');

          // Update URL without reload
          window.history.pushState({}, '', url);

          // Re-bind add to cart on new cards
          rebindAddToCart();
        })
        .catch(function() {
          collectionProducts.classList.remove('is-loading');
        });
    });
  }

  function rebindAddToCart() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      // Remove old listeners by cloning
      var newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);

      newForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(this);
        var submitBtn = this.querySelector('[type="submit"]');
        var originalText = submitBtn ? submitBtn.textContent : '';

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Aggiunto!';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          updateCartCount();
          showCartFeedback();
          setTimeout(function() {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = originalText;
            }
          }, 1500);
        })
        .catch(function() {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        });
      });
    });
  }

  /* --- SORT SELECT --- */
  var sortSelect = document.querySelector('.sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* --- COOKIE BANNER (GDPR) --- */
  var cookieBanner = document.getElementById('cookie-banner');
  var cookieAccept = document.getElementById('cookie-accept');
  var cookieDecline = document.getElementById('cookie-decline');

  if (cookieBanner) {
    // Check if user already made a choice
    if (!localStorage.getItem('elstar_cookie_consent')) {
      setTimeout(function() {
        cookieBanner.classList.add('is-active');
      }, 1000);
    }

    if (cookieAccept) {
      cookieAccept.addEventListener('click', function() {
        localStorage.setItem('elstar_cookie_consent', 'accepted');
        cookieBanner.classList.remove('is-active');
      });
    }

    if (cookieDecline) {
      cookieDecline.addEventListener('click', function() {
        localStorage.setItem('elstar_cookie_consent', 'declined');
        cookieBanner.classList.remove('is-active');
      });
    }
  }

  /* --- ANIMATED COUNTERS --- */
  var countersSection = document.getElementById('counters-section');
  if (countersSection && 'IntersectionObserver' in window) {
    var countersAnimated = false;
    var counterObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !countersAnimated) {
          countersAnimated = true;
          animateCounters();
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    counterObserver.observe(countersSection);
  }

  function animateCounters() {
    var counterEls = document.querySelectorAll('[data-counter-target]');
    counterEls.forEach(function(el) {
      var target = parseInt(el.getAttribute('data-counter-target')) || 0;
      var duration = 2000;
      var start = 0;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        // Ease-out cubic
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = Math.floor(eased * target);
        el.textContent = current.toLocaleString('it-IT');
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = target.toLocaleString('it-IT');
        }
      }

      requestAnimationFrame(step);
    });
  }

  /* --- TESTIMONIALS CAROUSEL --- */
  var testimonialsCarousel = document.getElementById('testimonials-carousel');
  if (testimonialsCarousel) {
    var tCards = testimonialsCarousel.querySelectorAll('.testimonial-card');
    var tDots = testimonialsCarousel.querySelectorAll('.testimonial-dot');
    var tPrev = testimonialsCarousel.querySelector('.testimonial-arrow--prev');
    var tNext = testimonialsCarousel.querySelector('.testimonial-arrow--next');
    var tCurrentIndex = 0;
    var tTotal = tCards.length;
    var tAutoplayInterval;

    function goToTestimonial(index) {
      if (index < 0) index = tTotal - 1;
      if (index >= tTotal) index = 0;
      tCurrentIndex = index;
      tCards.forEach(function(c, i) {
        c.classList.toggle('is-active', i === tCurrentIndex);
      });
      tDots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === tCurrentIndex);
      });
    }

    if (tPrev) tPrev.addEventListener('click', function() {
      goToTestimonial(tCurrentIndex - 1);
      resetTAutoplay();
    });

    if (tNext) tNext.addEventListener('click', function() {
      goToTestimonial(tCurrentIndex + 1);
      resetTAutoplay();
    });

    tDots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToTestimonial(parseInt(this.getAttribute('data-slide')));
        resetTAutoplay();
      });
    });

    function startTAutoplay() {
      tAutoplayInterval = setInterval(function() {
        goToTestimonial(tCurrentIndex + 1);
      }, 6000);
    }
    function resetTAutoplay() {
      clearInterval(tAutoplayInterval);
      startTAutoplay();
    }
    if (tTotal > 1) startTAutoplay();
  }

  /* --- PRODUCT ACCORDION (MOBILE) --- */
  document.querySelectorAll('.accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var item = this.closest('.accordion-item');
      if (!item) return;
      var isOpen = item.classList.contains('is-open');
      // Close all siblings
      var parent = item.parentElement;
      if (parent) {
        parent.querySelectorAll('.accordion-item').forEach(function(sibling) {
          sibling.classList.remove('is-open');
          var siblingTrigger = sibling.querySelector('.accordion-trigger');
          if (siblingTrigger) siblingTrigger.setAttribute('aria-expanded', 'false');
        });
      }
      // Toggle current
      if (!isOpen) {
        item.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* --- WISHLIST (localStorage) --- */
  var wishlistBtn = document.getElementById('wishlist-btn');
  if (wishlistBtn) {
    var productId = wishlistBtn.getAttribute('data-product-id');
    var wishlist = JSON.parse(localStorage.getItem('elstar_wishlist') || '[]');

    // Check if already in wishlist
    if (wishlist.indexOf(productId) !== -1) {
      wishlistBtn.classList.add('is-active');
    }

    wishlistBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var current = JSON.parse(localStorage.getItem('elstar_wishlist') || '[]');
      var idx = current.indexOf(productId);

      if (idx !== -1) {
        // Remove from wishlist
        current.splice(idx, 1);
        this.classList.remove('is-active');
      } else {
        // Add to wishlist
        current.push(productId);
        this.classList.add('is-active');
      }

      localStorage.setItem('elstar_wishlist', JSON.stringify(current));
    });
  }

  /* --- BOUGHT TOGETHER --- */
  var btAddAll = document.getElementById('bt-add-all');
  var btTotalPrice = document.getElementById('bt-total-price');

  function updateBtTotal() {
    if (!btTotalPrice) return;
    var total = 0;
    // Always include main product
    var mainVariant = document.querySelector('.bought-together-item--current .bt-variant');
    if (mainVariant) {
      total += parseInt(mainVariant.getAttribute('data-price')) || 0;
    }
    // Include checked items
    document.querySelectorAll('.bt-checkbox:checked').forEach(function(cb) {
      total += parseInt(cb.getAttribute('data-price')) || 0;
    });
    // Format as money (Shopify prices are in cents)
    var formatted = (total / 100).toFixed(2).replace('.', ',');
    btTotalPrice.textContent = '\u20AC' + formatted;
  }

  if (btTotalPrice) {
    updateBtTotal();
    document.querySelectorAll('.bt-checkbox').forEach(function(cb) {
      cb.addEventListener('change', updateBtTotal);
    });
  }

  if (btAddAll) {
    btAddAll.addEventListener('click', function() {
      var items = [];
      // Main product
      var mainVariant = document.querySelector('.bought-together-item--current .bt-variant');
      if (mainVariant) {
        items.push({ id: parseInt(mainVariant.value), quantity: 1 });
      }
      // Checked extras
      document.querySelectorAll('.bt-checkbox:checked').forEach(function(cb) {
        items.push({ id: parseInt(cb.getAttribute('data-variant-id')), quantity: 1 });
      });

      if (items.length === 0) return;

      var btn = btAddAll;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Aggiunta in corso...';

      // Add items sequentially
      var addNext = function(index) {
        if (index >= items.length) {
          updateCartCount();
          showCartFeedback();
          btn.textContent = 'Aggiunti!';
          setTimeout(function() {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 1500);
          return;
        }
        var formData = new FormData();
        formData.append('id', items[index].id);
        formData.append('quantity', items[index].quantity);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function() { addNext(index + 1); })
          .catch(function() { addNext(index + 1); });
      };
      addNext(0);
    });
  }

  /* --- SALE COUNTDOWN TIMER --- */
  var countdownEl = document.getElementById('sale-countdown');
  if (countdownEl) {
    var endDateStr = countdownEl.getAttribute('data-end');
    var endDate = new Date(endDateStr).getTime();

    function updateCountdown() {
      var now = new Date().getTime();
      var diff = endDate - now;

      if (diff <= 0) {
        countdownEl.classList.add('is-expired');
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var secs = Math.floor((diff % (1000 * 60)) / 1000);

      var cdDays = document.getElementById('cd-days');
      var cdHours = document.getElementById('cd-hours');
      var cdMins = document.getElementById('cd-mins');
      var cdSecs = document.getElementById('cd-secs');

      if (cdDays) cdDays.textContent = days < 10 ? '0' + days : days;
      if (cdHours) cdHours.textContent = hours < 10 ? '0' + hours : hours;
      if (cdMins) cdMins.textContent = mins < 10 ? '0' + mins : mins;
      if (cdSecs) cdSecs.textContent = secs < 10 ? '0' + secs : secs;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* --- SHARE COPY LINK --- */
  var shareCopyBtn = document.getElementById('share-copy-btn');
  if (shareCopyBtn) {
    shareCopyBtn.addEventListener('click', function() {
      var url = this.getAttribute('data-url');
      var btn = this;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function() {
          btn.classList.add('is-copied');
          setTimeout(function() {
            btn.classList.remove('is-copied');
          }, 2000);
        });
      } else {
        // Fallback for older browsers
        var textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        btn.classList.add('is-copied');
        setTimeout(function() {
          btn.classList.remove('is-copied');
        }, 2000);
      }
    });
  }

  /* --- ESCAPE KEY HANDLERS --- */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeSearch();
      if (lightbox && lightbox.classList.contains('is-active')) {
        lightbox.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    }
  });

  /* ============================================
     FAQ ACCORDION
     ============================================ */
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.faq-item');
      var answer = item.querySelector('.faq-answer');
      var inner = answer.querySelector('.faq-answer-inner');
      var isOpen = item.classList.contains('is-open');

      // Close all others
      document.querySelectorAll('.faq-item.is-open').forEach(function(openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          openItem.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
          openItem.querySelector('.faq-answer').style.maxHeight = '0';
        }
      });

      // Toggle current
      if (isOpen) {
        item.classList.remove('is-open');
        this.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = '0';
      } else {
        item.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  });

  /* ============================================
     COLLECTION PAGE ENHANCEMENTS
     ============================================ */

  /* --- Mobile Filter Drawer --- */
  var filterToggle = document.getElementById('filter-toggle');
  var filterOverlay = document.getElementById('filter-overlay');
  var filterClose = document.getElementById('filter-close');
  var collectionSidebar = document.getElementById('collection-sidebar');

  function openFilterDrawer() {
    if (collectionSidebar) collectionSidebar.classList.add('is-active');
    if (filterOverlay) {
      filterOverlay.style.display = 'block';
      // Force reflow for transition
      filterOverlay.offsetHeight;
      filterOverlay.classList.add('is-active');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeFilterDrawer() {
    if (collectionSidebar) collectionSidebar.classList.remove('is-active');
    if (filterOverlay) {
      filterOverlay.classList.remove('is-active');
      setTimeout(function() { filterOverlay.style.display = 'none'; }, 300);
    }
    document.body.style.overflow = '';
  }

  if (filterToggle) filterToggle.addEventListener('click', openFilterDrawer);
  if (filterClose) filterClose.addEventListener('click', closeFilterDrawer);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilterDrawer);

  /* --- Filter Group Collapse/Expand --- */
  document.querySelectorAll('.filter-group-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var group = this.closest('.filter-group');
      if (group) group.classList.toggle('is-collapsed');
    });
  });

  /* --- Collection View Toggle (Grid/List) --- */
  var viewToggles = document.querySelectorAll('.view-toggle-btn');
  var collectionProductsGrid = document.getElementById('collection-products');

  viewToggles.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var view = this.getAttribute('data-view');
      viewToggles.forEach(function(b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');

      if (collectionProductsGrid) {
        if (view === 'list') {
          collectionProductsGrid.classList.add('view-list');
        } else {
          collectionProductsGrid.classList.remove('view-list');
        }
      }

      // Save preference
      try { localStorage.setItem('elstar_view_mode', view); } catch(e) {}
    });
  });

  // Restore saved view preference
  try {
    var savedView = localStorage.getItem('elstar_view_mode');
    if (savedView === 'list' && collectionProductsGrid) {
      collectionProductsGrid.classList.add('view-list');
      viewToggles.forEach(function(b) {
        b.classList.toggle('is-active', b.getAttribute('data-view') === 'list');
      });
    }
  } catch(e) {}

  /* --- Filter form auto-submit on checkbox change --- */
  var filterFormEl = document.getElementById('filter-form');
  if (filterFormEl) {
    document.querySelectorAll('.filter-label input[type="checkbox"]').forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        filterFormEl.submit();
      });
    });
  }

  /* ============================================
     PRODUCT PAGE ENHANCEMENTS
     ============================================ */

  /* --- Delivery Estimate (dynamic cutoff time) --- */
  var deliveryCutoff = document.getElementById('delivery-cutoff');
  var deliveryDetail = document.getElementById('delivery-estimate-detail');
  if (deliveryCutoff && deliveryDetail) {
    var now = new Date();
    var hour = now.getHours();
    var day = now.getDay(); // 0=Sunday, 6=Saturday

    if (day === 0 || day === 6) {
      // Weekend
      deliveryDetail.innerHTML = 'Ordina ora e <strong>spedizione luned&igrave;</strong> con consegna in <strong>24-48h</strong>';
    } else if (hour >= 14) {
      // After cutoff
      deliveryDetail.innerHTML = 'Ordina ora e <strong>spedizione domani</strong> con consegna in <strong>24-48h</strong>';
    }
    // else keep default: "Ordina entro le 14:00"
  }

  /* --- Recently Viewed Products --- */
  var productDataEl = document.getElementById('current-product-data');
  var recentlyViewedSection = document.getElementById('recently-viewed');
  var recentlyViewedGrid = document.getElementById('recently-viewed-grid');

  if (productDataEl) {
    try {
      var currentProduct = JSON.parse(productDataEl.textContent);
      var recentlyViewed = JSON.parse(localStorage.getItem('elstar_recently_viewed') || '[]');

      // Remove current product if already in list
      recentlyViewed = recentlyViewed.filter(function(p) { return p.id !== currentProduct.id; });

      // Show recently viewed (before adding current)
      if (recentlyViewed.length > 0 && recentlyViewedSection && recentlyViewedGrid) {
        var html = '';
        var shown = Math.min(recentlyViewed.length, 4);
        for (var i = 0; i < shown; i++) {
          var p = recentlyViewed[i];
          var priceHtml = '';
          if (p.compare_at_price && p.compare_at_price > p.price) {
            priceHtml = '<span class="price--on-sale"><span class="price--regular">' +
              formatMoney(p.compare_at_price) + '</span> ' + formatMoney(p.price) + '</span>';
          } else {
            priceHtml = formatMoney(p.price);
          }

          html += '<div class="product-card">' +
            '<div class="product-card-image"><a href="' + p.url + '">' +
            (p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="500" height="500">' : '') +
            '</a></div>' +
            '<div class="product-card-info">' +
            (p.vendor ? '<p class="product-card-vendor">' + escapeHtml(p.vendor) + '</p>' : '') +
            '<h3 class="product-card-title"><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></h3>' +
            '<div class="product-card-price">' + priceHtml + '</div>' +
            '</div></div>';
        }
        recentlyViewedGrid.innerHTML = html;
        recentlyViewedSection.style.display = '';
      }

      // Add current product to the beginning
      recentlyViewed.unshift({
        id: currentProduct.id,
        handle: currentProduct.handle,
        title: currentProduct.title,
        url: currentProduct.url,
        price: currentProduct.price,
        compare_at_price: currentProduct.compare_at_price,
        image: currentProduct.image,
        vendor: currentProduct.vendor,
        available: currentProduct.available
      });

      // Keep max 10 items
      if (recentlyViewed.length > 10) recentlyViewed = recentlyViewed.slice(0, 10);

      localStorage.setItem('elstar_recently_viewed', JSON.stringify(recentlyViewed));
    } catch(e) {}
  }

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* --- Close filter drawer on Escape --- */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (collectionSidebar && collectionSidebar.classList.contains('is-active')) {
        closeFilterDrawer();
      }
      // Close welcome popup on Escape
      var popup = document.getElementById('welcome-popup-overlay');
      if (popup && popup.classList.contains('is-active')) {
        popup.classList.remove('is-active');
      }
    }
  });

  /* --- WELCOME POPUP (10% Discount) --- */
  var welcomePopup = document.getElementById('welcome-popup-overlay');
  var welcomeClose = document.getElementById('welcome-popup-close');
  var welcomeForm = document.getElementById('welcome-popup-form');

  if (welcomePopup && !localStorage.getItem('elstar_popup_shown')) {
    // Show popup after 5 seconds
    setTimeout(function() {
      welcomePopup.classList.add('is-active');
      localStorage.setItem('elstar_popup_shown', '1');
    }, 5000);
  }

  if (welcomeClose) {
    welcomeClose.addEventListener('click', function() {
      welcomePopup.classList.remove('is-active');
    });
  }

  // Close popup when clicking overlay
  if (welcomePopup) {
    welcomePopup.addEventListener('click', function(e) {
      if (e.target === welcomePopup) {
        welcomePopup.classList.remove('is-active');
      }
    });
  }

  // Handle form submit
  if (welcomeForm) {
    welcomeForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = this.querySelector('input[type="email"]').value;
      if (email) {
        // Submit to Shopify customer API
        var formData = new FormData(this);
        fetch('/contact#contact_form', {
          method: 'POST',
          body: formData
        }).then(function() {
          welcomePopup.querySelector('.welcome-popup-content').innerHTML =
            '<div class="welcome-popup-badge" style="background:linear-gradient(135deg,#459447,#2d7a2f)">&#10003;</div>' +
            '<h3>Grazie!</h3>' +
            '<p>Controlla la tua email per ricevere il codice sconto del <strong>10%</strong>.</p>' +
            '<p class="welcome-popup-note">Il codice arriver&agrave; entro pochi minuti.</p>';
        }).catch(function() {
          welcomePopup.querySelector('.welcome-popup-content').innerHTML =
            '<div class="welcome-popup-badge" style="background:linear-gradient(135deg,#459447,#2d7a2f)">&#10003;</div>' +
            '<h3>Grazie!</h3>' +
            '<p>Ti invieremo il codice sconto del <strong>10%</strong> via email.</p>';
        });
      }
    });
  }

})();
